import React, { useState, useEffect, useCallback } from 'react';
import { useRouter } from "next/navigation";
import Link from "next/link";
import styles from './simpleMap.module.css';
import {
    AdvancedMarker,
} from '@vis.gl/react-google-maps';

type Props = {
    data: Result,
    setShowInfo: any,
    showInfo: any,
    onMouseLeave: any, onMouseEnter: any, setMarkerRef: any
}

type Result = {
    item: {
        thumbnail_uri: string,
        address: any,
        name: string
        resultHref: string,
        category_code: string
    },
    id: number | {raw: number},
    lat: number,
    lng: number,
}

const MarkerWithInfowindow: React.FC<Props> = ({ data, setShowInfo, showInfo, onMouseLeave, onMouseEnter, setMarkerRef }) => {
    const [infowindowOpen, setInfowindowOpen] = useState(false)
    let item = data.item;
    let thumbnail = item.thumbnail_uri ? `${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${item.thumbnail_uri}` : `${process.env.NEXT_PUBLIC_APP_CDN_URL}fallback-images/${item.category_code.toLowerCase()}-fullback.jpeg`
    const router = useRouter();
    const updateShow = (value) => {
        setInfowindowOpen(value)
        setShowInfo(value)
    }

    const ref = useCallback(
        (marker: google.maps.marker.AdvancedMarkerElement) =>
            setMarkerRef(marker, typeof data.id === 'object' ? data.id.raw : data.id),
        [setMarkerRef, data.id]
    );

    useEffect(() => {
        if (infowindowOpen) {
            setInfowindowOpen(showInfo)
        }
    }, [showInfo])
    return (<AdvancedMarker
        position={{ lat: data.lat, lng: data.lng }}
        onClick={() => updateShow(true)}
        style={{ zIndex: 1 }}
        ref={ref}
    >
        <div className={styles.mapMarker} key={typeof data.id === 'object' ? data.id.raw : data.id}
            onMouseEnter={() => onMouseEnter(data)} onMouseLeave={() => onMouseLeave(typeof data.id === 'object' ? data.id.raw : data.id)}
            onClick={() => {
                router.push(item.resultHref)
            }}
            id={`marker-${typeof data.id === 'object' ? data.id.raw : data.id}`}
        >
            <Link href={item.resultHref} passHref prefetch={false} >
                <div className={styles.mapToolKit} id={`tootlKit-${typeof data.id === 'object' ? data.id.raw : data.id}`}>
                    <div className={styles.mapToolKitImage}>
                        <img src={thumbnail} alt={item.address ? item.address.join(', ') : item.name} />
                    </div>
                    <div className={styles.mapToolKitInfo}>
                        <em>{item.address ? item.address.join(', ') : item.name} </em>
                    </div>
                </div>
            </Link>
        </div>


    </AdvancedMarker>
    );
};

export default MarkerWithInfowindow;